export default "__VITE_ASSET__DREe6giw__"